// A message and what it carries: actions, cards, files, the previewer, receipts (R10-Q16).
export const msg = {
  // Said in more than one place in the area.
  send: "Send",
  post: "Post",
  forward: "Forward",
  cancelled: "Cancelled",
  replacedByNewer: "Replaced by a newer message",
  thatDidntWork: "That didn't work",
  thatDidntWorkDot: "That didn't work.",
  progress: "Progress",
  addNoteOptional: "Add a note (optional)",
  download: "Download",
  downloadSize: "Download ({size})",
  askVantageAboutIt: "Ask Vantage about it",
  seconds: "{s} s",

  // A relay preview, leak or choice card (cardCopy.ts).
  editMessage: "Edit the message",
  editPost: "Edit the post",
  emailTo: "Email to {name}",
  sendTo: "Send to {name}",
  postTo: "Post to #{channel}",
  beforeSendTo: "Before I send this to {name}",
  beforePost: "Before I post this",

  // A capped table's "All N as a report" (deepAsk.ts).
  deepAllN: "all {n}",
  deepAllOfThem: "all of them",
  deepAsk: "{ask}: {all}, as a report.",
  deepAskFullList: "The full list ({all}), as a report.",

  // Receipts.
  undone: "Undone",
  partlyUndone: "Partly undone",
  changed: "Changed",
  shared: "Shared",
  couldntDoThat: "Couldn't do that just now.",
  onlyYouSee: "Only you can see this",

  // Forward.
  sentToName: "Sent to {name}.",
  postedToChannel: "Posted to #{channel}.",
  otherTeams: "other teams",
  leakLine: "This includes details from {what} that {target} can't see.",
  forwardThis: "Forward this message",
  couldntForward: "Couldn't forward it just now.",
  forwardTo: "Forward to",
  findSomeone: "Find someone or a channel…",
  peopleAndChannels: "People and channels",
  noOneMatches: "No one or no channel matches.",
  whatTheyCantSee: "What they can't see",
  sendAnyway: "Send anyway",
  to: "To",
  change: "Change",
  addNote: "Add a note",

  // A report's task card.
  durationMinS: "{m} min {s} s",
  durationMin: "{m} min",
  doneIn: "Done in {time}",
  taskFailed: "Stopped: it couldn't finish",
  started: "Started {time}",
  planning: "planning",
  underAMinuteLeft: "under a minute left",
  aboutMinLeft: "about {n} min left",
  couldntStop: "Couldn't stop it just now.",
  stopping: "Stopping…",
  stopReport: "Stop report",
  stopReportTitle: "Stop this report?",
  stopReportBody: "What it has gathered so far is dropped. You can run it again later.",
  runAgain: "Run again",

  // The R3 action cards.
  stepDone: "done",
  stepFailed: "failed",
  stepRunning: "in progress",
  stepWaiting: "waiting",
  expiredAskAgain: "Expired: ask again",
  onlyCanConfirm: "Only {name} can confirm this",
  workingOnIt: "Working on it…",
  answeredBelow: "Answered below",
  showNMore: "Show {n} more",
  andNMore: "and {n} more",
  nOfTotal: "{done} of {total}",
  accessInAppOnly: "Access changes are confirmed here in the app only.",
  partlyDone: "{done} of {total} done · {failed} failed",

  // 👍 / 👎.
  feedbackHint: "Your note teaches Vantage how to answer you.",
  feedbackHintTeam:
    "Your note teaches Vantage how to answer you. It becomes {team}'s when a teammate agrees.",
  couldntSaveRating: "Couldn't save that. Try again.",
  whatWasOff: "What was off?",
  pickAny: "Pick any",
  reasons: "Reasons",
  reasonWrong: "Wrong",
  reasonMissed: "Missed something",
  reasonSlow: "Too slow",
  reasonTooLong: "Too long",
  reasonNotOurWay: "Not how we do it",
  noteOptional: "Note (optional)",
  sendFeedback: "Send feedback",
  thanksFeedback: "Thanks. That helps Vantage do better.",
  goodAnswer: "Good answer",
  goodAnswerOn: "Good answer (selected)",
  needsWork: "Needs work",
  needsWorkOn: "Needs work (selected)",

  // A file's card and its lines (files.ts, FileCard.tsx).
  fileBadge: "FILE",
  filesUpTo: "Files can be up to {n} MB.",
  sheets_one: "{n} sheet",
  sheets_other: "{n} sheets",
  rows_one: "{n} row",
  rows_other: "{n} rows",
  rowsMore: "{n}+ rows",
  pages_one: "{n} page",
  pages_other: "{n} pages",
  pagesMore: "{n}+ pages",
  slides_one: "{n} slide",
  slides_other: "{n} slides",
  slidesMore: "{n}+ slides",
  pageN: "page {n}",
  pageNOf: "page {n} of {total}",
  slideN: "slide {n}",
  slideNOf: "slide {n} of {total}",
  endPagesOf: "That's the first {n} of {total} pages",
  endSlidesOf: "That's the first {n} of {total} slides",
  endFirstPages_one: "That's the first page",
  endFirstPages_other: "That's the first {n} pages",
  endFirstSlides_one: "That's the first slide",
  endFirstSlides_other: "That's the first {n} slides",
  sheetEnd: "That's the first {cap} of {total} rows",
  sheetEndMore: "That's the first {cap} of more than {total} rows",
  filePos_one: "{i} of {n} file",
  filePos_other: "{i} of {n} files",
  someone: "Someone",
  drawingFirstPage: "Drawing the first page…",
  openFile: "Open {name}",

  // The previewer.
  bodyPages: "Pages",
  bodySlides: "Slides",
  bodySheet: "Sheet",
  bodyPicture: "Picture",
  bodyText: "Text",
  bodyFile: "File",
  noPreview: "There's no preview for this kind of file.",
  previousFile: "Previous file",
  nextFile: "Next file",
  endOfPreview: "End of the preview",
  endHelp: "Download it for the rest, or ask Vantage: it reads the whole file.",
  noPages: "This file has no pages to show.",
  drawingPages: "Drawing the pages…",
  drawingPagesNote: "A big file takes a few seconds; each page appears as soon as it's ready.",
  pageAlt: "Page {n}",
  slideAlt: "Slide {n}",
  drawingPage: "Drawing page {n}",
  thisSheet: "this sheet",
  sheetUnreadable: "This sheet couldn't be read for a preview.",
  noSheets: "This file has no sheets to show.",
  sheetsLabel: "Sheets",
  sheetNamed: "Sheet {name}",
  sheetEmpty: "This sheet is empty.",
  loadingMoreRows: "Loading more rows…",
  couldntLoadMoreRows: "Couldn't load more rows.",
  pictureUnshown: "This picture couldn't be shown here. Download has the original.",
  fullSize: "Full size",
  noPagesNoText: "This file's pages couldn't be drawn, and it has no text to show.",
  itsText: "its text",
  textUnreadable: "Its text couldn't be read.",
  noText: "There's no text in it.",
  textTruncated: "That's the first 200,000 characters; Download has the whole file.",
  pagesNotDrawn: "This file's pages couldn't be drawn.",
  pagesNotDrawnNote: "Here's its text; Download has the original.",

  // A message, its header and its actions.
  sentByEmail: "Sent by email",
  byEmail: "by email",
  automation: "Automation",
  sample: "Sample",
  aboutFile: "About {name}: ",
  showAllSteps: "Show all {n} steps",
  plusMore: "+{n} more",
  emailOff: "Email is switched off in Settings.",
  couldntEmail: "Couldn't email it just now.",
  emailThisToMe: "Email this to me",
  emailMe: "Email me",
  sentToYourEmail: "Sent to your email.",
  messageActions: "Message actions",
  couldntRetry: "Couldn't retry just now.",
  tableInCopy: "[table]",
  couldntReact: "Couldn't react.",
  addReaction: "Add reaction",
  reactWith: "React {emoji}",
  replies_one: "{n} reply",
  replies_other: "{n} replies",
  lastReply: "Last reply {when}",
  justNow: "just now",
  minAgo: "{n} min ago",
  atTime: "at {time}",
  couldntAsk: "Couldn't ask just now.",
  yourQuestion: "Your question about this message",
  askPlaceholder: "Ask Vantage about this…",
  ask: "Ask",
  askVantageAboutThis: "Ask Vantage about this",
  rememberThis: "Remember this",
  remembered: "Remembered",
  rememberReview: "An admin will check it before Vantage remembers it.",
  rememberNothing: "Vantage found nothing to remember in that message.",
  couldntRemember: "Couldn't remember that just now.",
  replyInThread: "Reply in thread",
  copyLink: "Copy link",
  linkCopied: "Link copied",
  copyText: "Copy text",
  deleteMessage: "Delete message",
  deleteForEveryone: "Delete this message for everyone?",
  deleteThis: "Delete this message?",
  couldntDelete: "Couldn't delete it.",
  postedTo: "Posted to #{channel}",
  postedToBy: "Posted to #{channel} by {name}",
  emailedTo: "Emailed to {name}",
  sentTo: "Sent to {name}",
  choseBy: "{name} chose: {choice}",
  theyChose: "They chose: {choice}",
  cancelledBy: "Cancelled by {name}",
  expired: "Expired",
  personWhoAsked: "the person who asked",
  subjectLabel: "Subject:",
  attached: "Attached: {files}",
  onlyCanAnswer: "Only {name} can answer this.",
  onlyCanPost: "Only {name} can post it; you can cancel it.",
  onlyCanSend: "Only {name} can send it; you can cancel it.",
  askPrivately: "Ask privately",
  deleted: "This message was deleted.",
  viaVantage: "via Vantage, {label}",
  earlierAnswer: "Earlier answer",
  edited: "edited",
  sending: "sending…",
  working: "working",
  takingAWhile: "This is taking a while. I'll post here when it's ready.",
  stop: "Stop",
  makeTicket: "Make a ticket",
  couldntMakeTicket: "Couldn't make a ticket just now.",
  askVantage: "Ask Vantage",
  markUnreadFromHere: "Mark unread from here",
  couldntMarkUnread: "Couldn't mark it unread.",
  viewTrace: "View trace",
};
